<template lang="pug">
.mapa-container
    Mapa(
        ref='mapa',
        :showStatesLayers='true',
        :mapLayersConfigs='layersMaps',
        :mapConfig='mapConfig',
        :height='"450px"',
        :idMapa='"MapaConcentracaoVolumeContratos"',
        :atualizarMapa='true'
    )
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import DashboardRastreabilidadeServiceEmpresa from '@/services/DashboardRastreabilidadeServiceEmpresa';

export default {
    name: 'MapaConcentracaoVolumeContratos',
    components: {
        Mapa
    },
    data() {
        return {
            layersMaps: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    bufferControl: false
                }
            },
            rankingVolumeEstados: [],
            volumeTotal: 0.0
        };
    },
    methods: {
        async buscaConcentracaoVolumesContratos(filtro) {
            try {
                const { data } =
                    await DashboardRastreabilidadeServiceEmpresa.postRankingVolume(
                        filtro.idCultura,
                        filtro.idSafra,
                        filtro.idEstado,
                        filtro.idFornecedor,
                        filtro.idRegionalBunge,
                        filtro.idGerenteRegional,
                        filtro.idGerenteComercial,
                        filtro.idGestorTerritorial,
                        filtro.idTipoContrato
                    );
                this.rankingVolumeEstados = data;
                this.calculaVolumeTotal();
                this.adicionarDadosMapa();
            } catch {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.dashboard.mapa.erroBuscarDados'
                    )
                );
            }
        },
        adicionarDadosMapa() {
            this.layersMaps = [];

            if (
                this.rankingVolumeEstados &&
                this.rankingVolumeEstados.length > 0
            ) {
                this.rankingVolumeEstados.forEach(volumeEstado => {
                    this.layersMaps.push({
                        geoJson: volumeEstado.geometria,
                        style: this.getEstiloGeometria(volumeEstado)
                    });
                });
            }
        },
        getEstiloGeometria(volumeEstado) {
            return {
                color: '#f4872a',
                weight: 1,
                fill: true,
                fillColor: this.getFillColorGeometria(
                    volumeEstado.quantidadeContratos
                ),
                fillOpacity: 0.8
            };
        },
        calculaVolumeTotal() {
            this.volumeTotal = this.rankingVolumeEstados.reduce(
                (acumulador, item) => {
                    return acumulador + item.quantidadeContratos;
                },
                0
            );
        },
        getFillColorGeometria(quantidade) {
            const percentual = (quantidade * 100) / this.volumeTotal;

            if (percentual <= 20) {
                return '#c0a87a';
            } else if (percentual > 20 && percentual <= 40) {
                return '#cd9952';
            } else if (percentual > 40 && percentual <= 60) {
                return '#ce7d29';
            } else if (percentual > 60 && percentual <= 80) {
                return '#cf6c22';
            } else if (percentual > 80) {
                return '#ba5e1d';
            } else {
                return '#ffffff';
            }
        }
    }
};
</script>

<style lang="scss">
#MapaConcentracaoVolumeContratos {
    border-radius: $default-border-radius;
    margin-top: 13px;
}
</style>
